import { useTranslation } from "react-i18next"
// api
import { GetSuperCourseProgressesByStatusResponse } from "api"
// constants
import { languagesTransformer } from "i18n"
// types
import { Language } from "types/i18n"
import { Cover } from "types/courses"

export type NormalizedCourses = {
  [key: string]: {
    cmeTestPassed: boolean
    cmeTestPassedDate: string
    courseWatchedDate: string
    watchStatus: string
    cmePointsText: string
    courseId: number
    courseName: string
    specialtiesStr: string
    superCourseId: number
    cover?: Cover
    documentId: string
    externalCertificateEligible: boolean
  }[]
}

export const getNormalizedCourses = (
  fetchedCourse: GetSuperCourseProgressesByStatusResponse | undefined
): NormalizedCourses => {
  const { i18n } = useTranslation()
  const transformedLanguage = languagesTransformer[i18n.language.slice(0, 2) as Language]

  const normalizedCoursesByYears: NormalizedCourses = {}
  fetchedCourse?.data.forEach((course) => {
    const {
      courseWatchedDate,
      cmeTestPassed,
      cmeTestPassedDate,
      watchStatus,
      superCourse: { id: superCourseId, courses },
    } = course

    const currentCourse = courses.find(({ locale }) => locale === transformedLanguage)
    const currentCourseAttributes = currentCourse

    const courseWatchedYear = (courseWatchedDate || "")?.split("-")[0]

    const specialtiesStr =
      currentCourseAttributes?.specialties?.reduce((acc, { name }) => (acc ? `${acc}, ${name}` : name), "") || ""

    const normalizedCourse = {
      cmeTestPassed,
      cmeTestPassedDate,
      courseWatchedDate,
      watchStatus,
      cmePointsText: currentCourseAttributes?.cmePointsText || "",
      courseId: currentCourse?.id || 0,
      courseName: currentCourseAttributes?.courseName || "",
      cover: currentCourseAttributes?.cover,
      specialtiesStr,
      superCourseId,
      documentId: currentCourseAttributes?.documentId || "",
      externalCertificateEligible: !!currentCourseAttributes?.cmeTest?.externalCertificate,
    }

    normalizedCoursesByYears[courseWatchedYear] = [
      ...(normalizedCoursesByYears[courseWatchedYear] || []),
      normalizedCourse,
    ]
  })

  return normalizedCoursesByYears
}
